<!-- @component Tracks page views and events, integrating with Posthog. -->

<script lang="ts">
  import { page } from "$app/state";

  import { onMount } from "svelte";

  import {
    attachCloudfrontRequestId,
    identifyDatadogUser,
  } from "$lib/core/datadog-rum";
  import {
    identifyUser,
    setPosthog,
    setUserFlagTargeting,
  } from "$lib/core/posthog";
  import { posthogProjectApiKey } from "$lib/core/posthog-project";
  import { posthogState } from "$lib/core/posthog.svelte";
  import { user } from "$lib/identity/user";

  onMount(async () => {
    // Posthog is proxied via a custom route (/ph).
    // Load Posthog asynchronously to avoid increasing bundle size.
    // We may update this if using Posthog feature flags.
    await Promise.all([
      // import("posthog-js/dist/surveys" as any),
      // import("posthog-js/dist/exception-autocapture" as any),
      // import("posthog-js/dist/tracing-headers" as any),
      import("posthog-js/dist/web-vitals" as any),
    ]);
    const posthog = (await import("posthog-js/dist/module.no-external"))
      .default;
    posthog.init(posthogProjectApiKey, {
      api_host: "/ph",
      ui_host: "https://us.posthog.com",
      defaults: "2025-11-30",
      disable_session_recording: true,
    });
    // Set the PostHog instance globally so it can be accessed from other components
    setPosthog(posthog);
  });

  $effect(() => {
    attachCloudfrontRequestId(page.data.cloudfrontRequestId);
    identifyDatadogUser($user);
    if (!posthogState.current) return;
    identifyUser($user);
    setUserFlagTargeting($user);
  });
</script>
